const erpTypes = [
    { value: '0', label: 'API' },
    { value: '1', label: 'SELF' },
]

export default erpTypes;